import React from "react";
import "./Socials.scss";

const LinkedInLogo = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      className="social-logo"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_0_463"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.39269 4.20255C1.338 4.20255 0.482178 3.32897 0.482178 2.27428C0.482178 1.21959 1.338 0.36377 2.39269 0.36377C3.44738 0.36377 4.3032 1.21959 4.3032 2.27428C4.3032 3.32897 3.44738 4.20255 2.39269 4.20255ZM4.04397 16.2729H0.744962V5.65141H4.04397V16.2729ZM13.0994 16.2729H16.3913H16.3948V10.4383C16.3948 7.58323 15.7805 5.38508 12.4424 5.38508C10.8373 5.38508 9.7613 6.26576 9.32096 7.10028H9.27479V5.65141H6.11073V16.2729H9.40618V11.0136C9.40618 9.62868 9.66897 8.28991 11.3842 8.28991C13.0745 8.28991 13.0994 9.87016 13.0994 11.1024V16.2729Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_0_463)">
        <rect
          x="-2.45459"
          y="-1.45459"
          width="21.8182"
          height="21.8182"
          fill="#F7FAFF"
        />
      </g>
    </svg>
  );
};

export default LinkedInLogo;
